import React from 'react';
import styled from 'styled-components';

/**
 *  이미지 표현
 */

const CustomImgBlock = styled.img.attrs( props => ({src: props.src}))`
    ${props => props.w && `width: ${props.w}` };
    ${props => props.h && `height: ${props.h}`};
    ${props => props.mTop && `margin-top: ${props.mTop}` };
    ${props => props.mBottom && `margin-bottom: ${props.mBottom}` };
    ${props => props.radius && `border-radius: ${props.radius}` };
    border: ${props => props.border || 'none'};
    ${props => props.cursor && `cursor: ${props.cursor}` };
    ${props => props.overflow && `overflow: ${props.overflow}` };
    ${props => props.objectFit && `object-fit: ${props.objectFit}` };
`;

const CustomImg2 = ({ img_src, width, height, marginTop, marginBottom, radius, border, cursor, overflow, objectFit }) => {
    return (
        <CustomImgBlock  src={img_src} w={width} h={height}
                         mTop={marginTop} mBottom={marginBottom} border={border}
                         cursor={cursor} radius={radius} objectFit={objectFit} overflow={overflow}/>
    );
};

export default CustomImg2;
